import { NumberUtils } from '@/common/utils';

interface Props {
  value: number;
  /** Font size class of the ordinal suffix ("st", "nd", ...). */
  suffixClassName?: string;
}

/** "1st", "2nd", ... with a smaller ordinal suffix. */
export const OrdinalNumber = ({ value, suffixClassName = 'text-3xs' }: Props) => (
  <span className="tabular-nums">
    {value}
    <span className={`font-mono ${suffixClassName}`}>{NumberUtils.ordinalSuffix(value)}</span>
  </span>
);
